'use client';

import { useState } from 'react';

export const useProviderSignup = () => {
  const [error, setError] = useState<string>('');

  const handleProviderSignup = async (provider: string) => {
    try {
      setError('');

      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/auth/${provider}/oauth-url?mode=signup`
      );

      const data = await res.json();

      if (!res.ok) {
        const message =
          data?.error || `${provider}認証URLの取得に失敗しました（ステータス: ${res.status}）`;
        setError(message);
        throw new Error(message);
      }

      if (!data.url) {
        const message = `${provider}の認証URLが見つかりません`;
        setError(message);
        throw new Error(message);
      }

      window.location.href = data.url;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : `${provider}新規登録に失敗しました（不明なエラー）`;
      setError(message);
    }
  };

  return { handleProviderSignup, error };
};
